import { useEffect } from "react";
import {
  Label,
  ModalPopup,
  PopupDialogbox,
  PrimaryButton,
  SofturaTable,
  SwitchToggle,
} from "client/CommonComponents";
import "./AppArea.scss";
import AppAreaModal from "./AppAreaModal";
import MoreOptions from "client/CommonComponents/MoreOptions";
import { deleteOption, editOption } from "client/Components/Administraton/utils/constant";
import { useDispatch, useSelector } from "react-redux";
import UserManagementOperations from '../../../../../../redux/UserManagement/operations'
import userManageSelectors from '../../../../../../redux/UserManagement/selectors'

interface IProps {
  appAreaForm?: any;
  handleChange?: any;
  handleSubmit?: any;
  showCreateModal?: any
  currentItem?: any;
  showDeleteModal?: any;
  optionHandler?: any;
  handleDeleteModal?: any;
  handleCreateModal?: any;
  setAppAreaForm?: any;
  formError?: any;
  isSuccessDialogVisible?: any;
  handleFailurePopup?: any;
  handleClickPopup?: any;
  setCurrentItem?: any;
  setShowInfoModal?: any;
  showInfoModal?: any;
  handleDeleteClick?: any;
  handleInfoModal?: any;
  togglePopup?: any;
  Popupcontent?: any;
}

const AppArea = ({
  appAreaForm,
  handleChange,
  handleSubmit,
  currentItem,
  showDeleteModal,
  optionHandler,
  handleDeleteModal,
  handleCreateModal,
  showCreateModal,
  setAppAreaForm,
  formError,
  showInfoModal,
  handleDeleteClick,
  handleInfoModal,
  togglePopup,
  Popupcontent
}: IProps) => {
  const dispatch = useDispatch()
  const option = [editOption, deleteOption];
  const dispatchGetAppAreaList = UserManagementOperations.dispatchGetAppAreaList(dispatch);
  const {
    appAreaListingData,
    applicationListData,
    addAppAreaVal,
    checkAppArea,
    appAreaById
  }: any
    = useSelector(
      (state: any) => ({
        appAreaListingData: state.UserManagement.appAreaListingData,
        applicationListData: userManageSelectors.getApplicationListing(state),
        addAppAreaVal: userManageSelectors.getaddAppAreaVal(state),
        checkAppArea: userManageSelectors.checkAppArea(state),        
        appAreaById: state.UserManagement.appAreaById
      })
    )
  useEffect(() => {
    dispatchGetAppAreaList()
  }, [])
  const appAreaColumns = [
    {
      key: "action",
      title: "Action",
      Cell: (row: any) => {
        return (
          <MoreOptions
            onClick={optionHandler}
            options={option}
            {...row.rowData}
           data-attribute="AppArea_Default_MoreOptions" />
        );
      },
      width: 40,
    },
    {
      key: "applicationName",
      title: "Application",
      width: 200,
    },
    {
      key: "applicationAreaName",
      title: "Application Area",
      width: 200,
    },
    {
      key: "applicationAreaCode",
      title: "App Area Code",
      width: 200,
    },
    {
      key: "isActive",
      title: "Is Active",
      width: 100,
      Cell: (row: any) => {
        return (
          <SwitchToggle checked={row.rowData.isActive} onChange={() => { }}  data-attribute="AppArea_Default_SwitchToggle" />
        );
      },
    },
  ];

  return (
    <>
      <div className="app-grid-container">
        <div className="app-area-header">
          <span className="pull-left sub-head-text">App Area</span>
          <PrimaryButton
            text="Create New App Area"
            className="pull-right"
            onClick={togglePopup}
           data-attribute="AppArea_Default_Button" />
        </div>
        <div
          className={
            appAreaListingData?.data?.length !== 0
              ? "softura-table appArea-table"
              : "softura-table appArea-table paginationNav"
          }
        >
          <SofturaTable
            data={appAreaListingData?.data ?? []}
            columns={appAreaColumns}
            sort={true}
            defaultPageSize={10}
            pageSizes={[10, 20, 50]}
            globalSearch={false}
            filter={true}
           data-attribute="AppArea_Default_Grid" />
        </div>
      </div>
      {showCreateModal ? (
        <ModalPopup
          ShowModalPopupFooter={true}
          ModalPopupTitle={appAreaById?.hasOwnProperty("id") ? "Edit App Area" : "Add New App Area"}
          ModalPopupType="medium"
          FooterSecondaryBtnTxt="Cancel"
          FooterPrimaryBtnTxt="Save"
          closeModalPopup={handleCreateModal}
          PrimaryBtnOnclick={handleSubmit}
          SecondryBtnOnclick={handleCreateModal}
         data-attribute="AppArea_Default_ModalPopup">
          <AppAreaModal
            applicationListData={applicationListData}
            appAreaForm={appAreaForm}
            handleChange={handleChange}
            formError={formError}
            setAppAreaForm={setAppAreaForm}
          />
        </ModalPopup>
      ) : (
        ""
      )}
      {showDeleteModal ? (
        <ModalPopup
          ShowModalPopupFooter={true}
          ModalPopupTitle="Delete App Area"
          ModalPopupType="medium"
          FooterSecondaryBtnTxt="No"
          FooterPrimaryBtnTxt="Yes"
          closeModalPopup={handleDeleteModal}
          PrimaryBtnOnclick={handleDeleteClick}
          SecondryBtnOnclick={handleDeleteModal}
         data-attribute="AppArea_Default_ModalPopup_2">
          <Label data-attribute="AppArea_Default_Label">Are you sure you want to delete "{currentItem?.applicationAreaName}" ?</Label>
        </ModalPopup>
      ) : (
        ""
      )}
      <div className="appAreaInfo-Modal">
        {showInfoModal ? (
          <ModalPopup
            ShowModalPopupFooter={true}
            ModalPopupTitle="Information"
            ModalPopupType="medium"
            FooterPrimaryBtnTxt="Ok"
            closeModalPopup={handleInfoModal}
            PrimaryBtnOnclick={handleInfoModal}
           data-attribute="AppArea_Default_ModalPopup_3">
            <Label data-attribute="AppArea_Default_Label_2">Successfully deleted "{currentItem?.applicationAreaName}"</Label>
          </ModalPopup>
        ) : (
          ""
        )
        }
      </div>
      {addAppAreaVal > 0 || checkAppArea || addAppAreaVal == "error" ? (
        <PopupDialogbox
          hideDialog={!Popupcontent.isDialogVisible}
          onDismiss={() => Popupcontent?.popupOutlinebtnOnclick()}
          Popupcontent={Popupcontent}
          popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
          popupPrimarybtnOnclick={(
            item: any,
            actionby: string,
            value: any) => Popupcontent?.popupPrimarybtnOnclick(item,
              actionby,
              value)}
         data-attribute="AppArea_Default_PopupDilalogBox" />
      ) : null}
    </>
  );
};

export default AppArea;
